import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from '../Loaders/LazyLoad';
import SpinLoader from '../Loaders/SpinLoader';
import MessageBox from './MessageBox';

const NoResultsMessage = ({ title, text, cta, loading, ...rest }) => {
  let loader;
  if (loading === true) {
    loader = (
      <LazyLoad posAbsolute>
        <SpinLoader black />
      </LazyLoad>
    );
  }

  return (
    <MessageBox {...rest}>
      <p className="message-box__title like-h4 fw-bold">{title}</p>

      {text &&
        <p className="like-h5 text-grey">{text}</p>
      }

      {cta && cta}

      {loader}
    </MessageBox>
  );
};

NoResultsMessage.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  cta: PropTypes.object,
  loading: PropTypes.bool,
};

export default NoResultsMessage;



// WEBPACK FOOTER //
// ./library/app/components/Global/Messages/NoResultsMessage.js